module.exports = __webpack_public_path__ + "static/media/flame.a7b57102.svg";